import { COOKIES_REFRESH_TOKEN_KEY, COOKIES_TOKEN_KEY } from "constants/api";
import Cookies from "js-cookie";
import { domainCookies, setTimeoutConfirmRefreshToken } from "./helpers";

const defaultOptions = {
    domain: domainCookies(),
    expires: 365,
    secure: true
}

export const SESSION_COOKIE_EVENT = 'vmp:session-cookie-change';

const notifySessionCookieChange = (authenticated) => {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(SESSION_COOKIE_EVENT, {
        detail: { authenticated },
    }));
};

export const setCookies = (key, value, options) => {
    Cookies.set(key, value, options);
}
export const getCookies = (key) => {
    return Cookies.get(key);
}
export const removeCookies = (key, options) => {
    Cookies.remove(key, options);
}
export const setAccessToken = (accessToken) => {
    Cookies.set(COOKIES_TOKEN_KEY, accessToken, defaultOptions)
}
export const setRefreshToken = (refreshToken) => {
    Cookies.set(COOKIES_REFRESH_TOKEN_KEY, refreshToken, defaultOptions);
    setTimeoutConfirmRefreshToken()
}
export const setTokens = (accessToken, refreshToken) => {
    setRefreshToken(refreshToken)
    setAccessToken(accessToken)
    notifySessionCookieChange(Boolean(accessToken))
}

export const getAccessToken = () => {
    const token = getCookies(COOKIES_TOKEN_KEY)

    return token
}

export const getRefreshToken = () => {
    const refresh_token = getCookies(COOKIES_REFRESH_TOKEN_KEY)

    return refresh_token
}

export const getTokens = () => {
    const accessToken = getAccessToken()
    const refreshToken = getRefreshToken()
    return { accessToken, refreshToken }
}

export const clearAccessToken = () => {
    removeCookies(COOKIES_TOKEN_KEY, defaultOptions)
}
export const clearRefreshToken = () => {
    removeCookies(COOKIES_REFRESH_TOKEN_KEY, defaultOptions);
}
export const clearTokens = () => {
    clearRefreshToken()
    clearAccessToken()
    notifySessionCookieChange(false)
}
